export default class PdpAddToCartFixBtn extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        return (
            <div className="showMobile snackBarWrapper">
                <div className="pdp-error-display alert alert-danger alert-dismissible hidden pdplanding-error" role="alert">
                    <span className="p1 bold alert-message"></span>
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">{this.props.DismissText}</button>
                </div>
                <div className="AddBtnWrapper">
                    <div className="handle-counter">
                        <button className="btn counter-minus" aria-label="remove quantity" onClick={(e) => { e.preventDefault(); this.props.decreaseCounter(); }} disabled={this.props.count == 1 ? "disbaled" : ""}>-</button>
                        <input type="text" className="quantityinput" aria-label="item-count" readOnly={true} value={this.props.count} />
                        <button className="btn counter-plus" aria-label="add quantity" onClick={(e) => { e.preventDefault(); this.props.increaseCounter(); }} disabled={this.props.count >= this.props.AllowedMaxQuantity ? "disbaled" : ""}>+</button>
                    </div>
                    {this.props.CartItem == null ?
                        <button type="button" className="btn btn-primary btn-lg btn-add-cart" data-choice-id={this.props.dataChoiceAttributeIds} data-alcohol={this.props.isAlcohol} onClick={() => this.props.addToCart()}>Add To Bag - ${this.props.getPrice()}</button>
                        :
                        <button type="button" className="btn btn-primary btn-lg btn-add-cart" data-choice-id={this.props.dataChoiceAttributeIds} data-alcohol={this.props.isAlcohol} onClick={() => this.props.addToCart()}>Update - ${this.props.getPrice()}</button>
                    }
                </div>
            </div>
        )
    }
}
